import PostCard from "@/components/utils/PostCard/PostCard";
import { PostCardGridPropTypes } from "./propTypes";
import Masonry from "react-masonry-css";
import "./styles.scss";

const breakpointColumnsObj = {
  default: 3,
  1024: 2,
  768: 1,
  0: 1,
};


const PostCardGrid = ({ posts, entryType }) => (
  <div className="post-card-grid">
    <Masonry
      breakpointCols={breakpointColumnsObj}
      className="post-card-masonry"
      columnClassName="post-card-column"
    >
      {posts &&
        posts.map((el, index) => {
          let postProps = {
            title: el.title.rendered,
            image: {
              url:
                el._embedded && el._embedded["wp:featuredmedia"]
                  ? el._embedded["wp:featuredmedia"][0].source_url
                  : null,
            },
            type: entryType,
            link: { title: el.title.rendered, url: el.link },
            isStacked: true,
          };

          const categories = [];
          const tags = [];

          if (el._embedded && el._embedded["wp:term"]) {
            el._embedded["wp:term"].forEach((term) => {
              term.forEach((val) => {
                if (val.taxonomy === "category") {
                  categories.push(val.name);
                } else if (val.taxonomy === "post_tag") {
                  tags.push(val.name);
                }
              });
            });
          }

          postProps = { ...postProps, categories, tags };

          return <PostCard key={index} {...postProps} />;
        })}
      </Masonry>
  </div>
);

PostCardGrid.propTypes = PostCardGridPropTypes;

export default PostCardGrid;
